import React from 'react'

import { ButtonProps } from '@/components/commons'
import { NotificationSystem } from '@/components/commons/notifications/NotificationSystem.component'

export const RecommendationListEmpty = () => {
  const [show, setShow] = React.useState(true)
  const images = [
    {
      image: '/assets/avatar-logo-pink.png',
      alt: 'avatar',
      size: '100%',
    },
  ]
  const texts = [
    (<span className='font-bold' key={'recommendation-title-bold-text'}>Enhance your networking and complete your profile to receive network recommendations.</span>),
    'Add a profile image and choose your Creator Type, Content Categories, and Collab Types so we can recommend professionals and creators to connect with on Creatorland!',
  ]
  const buttons: ButtonProps[] = [
    {
      label: 'Ok, great!',
      variation: 'primary',
      size: 'xSmall',
      onClick: () => setShow(false),
    },
    {
      label: 'I\'ll do it later',
      variation: 'secondary',
      size: 'xSmall',
      onClick: () => setShow(false),
    },
  ]

  if (!show) return null

  return (
    <NotificationSystem images={images} texts={texts} buttons={buttons} />
  )
}